import { render, staticRenderFns } from "./BrokerInvoice.vue?vue&type=template&id=388fbc68"
import script from "./BrokerInvoice.vue?vue&type=script&lang=js"
export * from "./BrokerInvoice.vue?vue&type=script&lang=js"
import style0 from "./BrokerInvoice.vue?vue&type=style&index=0&id=388fbc68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports